<template>
  <!-- 회원가입 -->
  <div class="p-member-wrap">
    <div class="c-hgroup is-pc">
      <h1 class="c-title-level1">노루페인트 PAINT PRO 회원가입</h1>
    </div>

    <div class="c-process">
      <ol>
        <li>
          <span class="step-circle"></span>
          <span class="text">약관동의</span>
        </li>
        <li>
          <span class="step-circle"></span>
          <span class="text">정보입력</span>
        </li>
        <!-- D: 현재 단계 is-current 추가 -->
        <li class="is-current" aria-current="step">
          <span class="step-circle"></span>
          <span class="text">가입완료</span>
        </li>
      </ol>
    </div>

    <form action="">
      <div class="join-complete">
        <div class="join-img">
          <img src="@/assets/images/etc/img_join_complete.svg" alt="" />
        </div>
        <p class="text">회원가입이 완료되었습니다.</p>
      </div>

      <div class="c-btn-area">
        <a href="#" class="c-button type-primary">
          <span>로그인</span>
        </a>
      </div>
    </form>
  </div>
</template>
<script setup name="regisComplete"></script>
